const theme = {
  accent: "#D7615A",
  primary: "#E1D0BA",
  secondary: "#8CA6A6",
  text: "#232018",
  lightGray: "#d6d6d6",
  mainBg: "#fbf7f0",
};

export default theme;
